import { render, staticRenderFns } from "./MainPane.vue?vue&type=template&id=6df3bf73&"
import script from "./MainPane.vue?vue&type=script&lang=js&"
export * from "./MainPane.vue?vue&type=script&lang=js&"
import style0 from "./MainPane.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports